<template>
    <div class="pc-footer">
        <div class="footer-content">
            <div class="top" v-html="$t('footer_1')"></div>
            <div class="content">
                <div class="left">
                    <div class="text">{{$t('footer_2')}}</div>
                    <div class="share">
                        <a target="_blank" href="https://www.facebook.com/blowupcoin"><i class="icon-1"></i></a>
                        <a target="_blank" href="https://twitter.com/blowupcoin?s=21"><i class="icon-2"></i></a>
                        <a target="_blank" href="https://t.me/blowupcoin"><i class="icon-3"></i></a>
                        <a target="_blank" href="https://www.instagram.com/blowupcoin"><i class="icon-4"></i></a>
                        <a target="_blank" href="https://www.reddit.com/u/blowupcoin/"><i class="icon-5"></i></a>
                    </div>
                </div>
                <div class="right">
                    <div class="text">{{$t('footer_3')}}</div>
                    <div class="buttons">
                        <a target="_blank" :href="cpd_wp">{{$t('footer_4')}}</a>
                        <a target="_blank" href="https://bscscan.com/token/0x8b4F96981e79d633A796Dc06672A9928CCE5aBA7">BscScan</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PcFooter',
    data() {
        return {
        }
    },
    computed: {
        cpd_wp() {
            return `http://www.blowupcoin.com/files/white_paper_eng.pdf?${new Date().getTime()}`
        }
    },
    methods: {
    }
}
</script>

<style lang="less">
.pc-footer {
    height: 380px;
    width: 100%;
    overflow: hidden;
    .footer-content {
        width: 100%;
        background-color: #D0423F;
        background-image: url("../../assets/images/pc/footer.png");
        background-size: auto 120%;
        background-position: center 50px;
        background-repeat: repeat-x;
        height: 520px;
        padding: 8px 0;
    }
    .top {
        padding: 24px 0;
        text-align: center;
        color: #fff;
        font-size: 20px;
    }
    .content {
        width: 860px;
        margin: 0 auto;
        display: flex;
        .left {
            flex: 3;
            display: flex;
            flex-direction: column;
            border-right: solid 1px #fff;
            .text {
                color: #fff;
            }
            .share {
                display: flex;
                padding: 12px 0 0 0;
                a {
                    display: flex;
                    margin-right: 16px;
                    i {
                        width: 23.8px;
                        height: 24.5px;
                        background-size: 100%;
                        background-repeat: no-repeat;
                        &.icon-1 {
                            background-image: url("../../assets/images/pc/footer-1.png");
                        }
                        &.icon-2 {
                            background-image: url("../../assets/images/pc/footer-2.png");
                        }
                        &.icon-3 {
                            background-image: url("../../assets/images/pc/footer-3.png");
                        }
                        &.icon-4 {
                            background-image: url("../../assets/images/pc/footer-4.png");
                        }
                        &.icon-5 {
                            background-image: url("../../assets/images/pc/footer-5.png");
                        }
                    }
                }
            }
        }
        .right {
            flex: 2;
            padding-left: 60px;
            .text {
                color: #fff;
            }
            .buttons {
                display: flex;
                padding-top: 12px;
                a {
                    color: #D0423F;
                    line-height: 28px;
                    background-color: #ffffff;
                    padding: 0 24px;
                    margin-right: 24px;
                    border-radius: 5px;
                    font-family: ChalkboardSE-light;
                    font-size: 16px;
                }
            }
        }
    }

}
</style>
